import startLocation from '../shared/playStartLocation.js';
export const { PLAY_START_PLACE_NAMES, buildSettlementStartLocation } = startLocation;
